import React from 'react';
import { BarLoader } from 'react-spinners';


class SpinnerComponent extends React.Component {
    state = {
        loading: true
    };
	render() {
		console.log(this.props);
		return (
			<div className='sweet-loading'>
				<BarLoader
					className="clip-loader"
					sizeunit={"px"}
					size={60}
					color={'#FF586B'}
					loading={this.state.loading}
				/>
			</div> 
		)
	}
}

export default SpinnerComponent;